import PageContainer from 'components/PageContainer/PageContainer';
import React from 'react';
import RespuestaServidor from './RespuestaServidor';
import { Pause } from '@mui/icons-material';
import PasosDeCompra from 'components/public/FichaEspectaculo/PasosDeCompra';

const PendingCompra = () => {
  return (
    <PageContainer>
      <PasosDeCompra paso={3} />
      <RespuestaServidor
        titulo="Tu pago está en proceso"
        texto="Recibirás un correo cuando finalice la transacción."
        icono={Pause}
        textoBoton="Volver"
        colorIcono="warning"
        paginaANavegar={'/'}
      />
    </PageContainer>
  );
};

export default PendingCompra;
